<template>
  <div class="page page-search">
    <div class="container">
      <searchbar/>
    </div>
  </div>
</template>
<script>
import Searchbar from '@/components/Searchbar/Searchbar'
export default {
  components: { Searchbar }
}
</script>



// WEBPACK FOOTER //
// src/pages/Search.vue